// hooks/useQueryClient.ts
import { useMemo } from "react";
import { QueryClient } from "react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import ErrorUtils from "../utils/ApiUtils/ErrorUtils";
import useAuth from "./useAuth";

export const useQueryClient = () => {
  const { logOutAction } = useAuth();

  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          refetchOnMount: false,
          retry: false,
          onError: (error: any) => {
            if (error instanceof AxiosError) {
              if (error.response?.status === 401) {
                toast.error("Vous devez être connecté pour accéder à cette ressource, veuillez vous reconnecter", {
                  autoClose: false,
                });
                logOutAction(true);
              } else {
                console.log("Erreur query : " + JSON.stringify(error));
                toast.error(ErrorUtils.getErrorMessage(error), {
                  autoClose: false,
                });
              }
            } else {
              console.log("Erreur query : " + JSON.stringify(error));
              toast.error(ErrorUtils.getErrorMessage(error), {
                autoClose: false,
              });
            }
          },
        },
        mutations: {
          onError: (error: any) => {
            console.error("Erreur mutation : " + JSON.stringify(error));
            toast.error(ErrorUtils.getErrorMessage(error), {
              autoClose: false,
              closeOnClick: true,
            });
          },
        },
      },
    });
  }, [logOutAction]);

  return queryClient;
};
